import {
	EVENT_SETSTORE_SUCCESS,
	LOCAL_STORE_POSTCODE,
	PICKUP_CLASS,
	STOCK_CLASS,
} from './constants';
import {callApi} from './api';
import {checkLocalStorage, saveSelectedStore, storeNameShorter} from './findInStore';
import {dispatchEvent} from './utils';
import {EVT_SET_REGION} from '../../views/widgets/regionStorePopup/js/regionStorePopup';
import _ from 'lodash';

export function updateStockData(
	{
		addressName,
		storeId,
		url = '/api/check-out/stock-data',
	}
) {
	const {
		storeInfo: {
			contentLinkID,
			storeName,
		},
	} = checkLocalStorage();

	const storeSelectedID = storeId || contentLinkID;
	const $nearbyContainer = $('.delivery-description.clickCollect, .nearby-store-container');
	const $collectionStoreContainer = $('.search-click-collect-stores');
	const $availability = $('.availability-text');

	return new Promise((resolve, reject) => {
		if (storeSelectedID) {
			const $clickColletDescription = $('.deliveryMethodItemDescription-clickAndCollect');
			const $statusStock = $('.branch-item.is-selected .status-stock');
			const $statusStockMethod = $('.delivery-description .status-stock');
			const $addressName = $('.clickCollect .delivery-description-title');
			callApi(url, {
				contentLinkID: storeSelectedID,
			}).then(function(res) {
				if (res.result === 'SUCCESS') {
					const $miniCartStockPickup = $('.miniCart-stock-pickup');
					const $collectionStore = $('#collectionStore');
					const {
						DeliveryMethodResponse,
						StockData: {
							PickupStatusMsg,
							VariantStockValue,
							IsSamedayClickAndCollect,
							PickupStatus,
							StoreAddress,
							StoreName,
							MessageOnOrder,
							StoreId,
							HasAnyHeavyItem,
						},
					} = res;

					$('#IsSamedayClickAndCollect').val(IsSamedayClickAndCollect);
					$collectionStore.val(storeId || contentLinkID);
					$clickColletDescription.text(StoreAddress);
					$addressName.text(StoreName);
					updatePrice(DeliveryMethodResponse);
					updateHeavyClass(HasAnyHeavyItem);
					updateNearbyStore(StoreId);

					// Check is same day in setting
					if (window.enableSameDayClickAndCollect) {
						$availability
							.text(MessageOnOrder)
							.removeClass(Object.values(PICKUP_CLASS).join(' '))
							.addClass(PICKUP_CLASS[PickupStatus] || '');

						$miniCartStockPickup
							.text(PickupStatusMsg)
							.removeClass(Object.values(PICKUP_CLASS).join(' '))
							.addClass(PICKUP_CLASS[PickupStatus] || '');

						const $pickup = $(`<div ${ isNullOrWhiteSpace(PickupStatusMsg) ? 'hidden' : '' }  class="status-stock-text ${PICKUP_CLASS[PickupStatus] || ''}">${PickupStatusMsg || ''}</div>`);
						$statusStock.length && $statusStock.html($pickup);
						$statusStockMethod.length && $statusStockMethod.html($pickup.clone());
						setStockMiniCart(VariantStockValue, addressName || storeName);
					}
				} else {
					$clickColletDescription.text($clickColletDescription.data('description'));
				}
				resolve();
			}).catch(function() {
				$clickColletDescription.text($clickColletDescription.data('description'));
				reject();
			});
		} else {
			$nearbyContainer.addClass('d-none');
			$collectionStoreContainer.addClass('is-active');
			reject();
		}
	});
}

export function getStockData($store, storeInfo, {
	contentLinkId,
	addressName,
    url = '/api/check-out/stock-data',
}) {
	const $content = $store.find('.icon-wrapper, .name-address, .status-stock');
	const $statusStock = $store.find('.status-stock');
	const $statusStockMethod = $('.delivery-description .status-stock');
	const $clickColletDescription = $('.deliveryMethodItemDescription-clickAndCollect');
	const $addressName = $('.clickCollect .delivery-description-title');
	const $loading = $(`
	<div class="loading-stock">
		<div class="spinner-border spinner-border-sm" role="status">
			<span class="sr-only">Loading...</span>
		</div>
	</div>`);
	const $deliveryDescription = $('.delivery-description.clickCollect');
	const $searchClickCollectStores = $('.search-click-collect-stores');
	const $nearbyStoreContainer = $('.nearby-store-container');
	const $availability = $('.availability-text');

	$store
		.append($loading)
		.css('pointer-events', 'none');

	$loading.animate({opacity: 1}, 'fast');
	$content.animate({opacity: 0.1}, 'fast');

	function handleApiError() {
		$content.animate({opacity: 1}, 'fast');
		$loading.animate({opacity: 0}, 'fast', () => {
			$loading.remove();
		});
		$clickColletDescription.text($clickColletDescription.data('description'));
		$store.css('pointer-events', 'initial');
		cleanStock();
	}

	saveStore(storeInfo, function() {
		callApi(url, {
			contentLinkId,
		}).then(function(res) {
			if (res.result === 'SUCCESS') {
				const {
					DeliveryMethodResponse,
					StockData: {
						PickupStatus,
						PickupStatusMsg,
						VariantStockValue,
						IsSamedayClickAndCollect,
						StoreAddress,
						StoreName,
						MessageOnOrder,
						HasAnyHeavyItem,
					},
				} = res;

				$addressName.text(StoreName);
				$clickColletDescription.text(StoreAddress);
				$content.animate({opacity: 1}, 'fast');
				$loading.animate({opacity: 0}, 'fast', () => {
					$loading.remove();
				});

				$store.css('pointer-events', 'initial');
				$deliveryDescription.removeClass('d-none');
				$searchClickCollectStores.removeClass('is-active');
				$nearbyStoreContainer.removeClass('d-none');
				updatePrice(DeliveryMethodResponse);
				updateNearbyStore(storeInfo.storeId);
				updateHeavyClass(HasAnyHeavyItem);
				$('#IsSamedayClickAndCollect').val(IsSamedayClickAndCollect);

				// Check is same day in setting
				if (window.enableSameDayClickAndCollect) {
					const $pickup = $(`<div ${ isNullOrWhiteSpace(PickupStatusMsg) ? 'hidden' : '' } class="status-stock-text ${PICKUP_CLASS[PickupStatus] || ''}">${PickupStatusMsg || ''}</div>`);
					$statusStock.html($pickup);
					$statusStockMethod.length && $statusStockMethod.html($pickup.clone());
					setStockMiniCart(VariantStockValue, addressName);
					$availability
						.text(MessageOnOrder)
						.removeClass(Object.values(PICKUP_CLASS).join(' '))
						.addClass(PICKUP_CLASS[PickupStatus] || '');
				}
			} else {
				handleApiError();
			}
		}).catch(function() {
			handleApiError();
		});
	});
}

function updateNearbyStore(storeId) {
	const $nearbyStores = $('.nearbyStores');
	$nearbyStores.length && $nearbyStores.attr('data-store-id', storeId);
}

function renderDescription(addressName, pickupStatusMsg) {
	return `${storeNameShorter(addressName)} ${!isNullOrWhiteSpace(pickupStatusMsg) ? ` - ${pickupStatusMsg}` : ''}`;
}

export function isNullOrWhiteSpace(value) {
	return !value || !value.replace(/\s/gi, '').length;
}

export function cleanStock() {
	$('.miniCart .miniCart-stock, .cartStep_1Page .shoppingCartItem-stock').empty();
}

function updatePrice(data) {
	const {
		shipping,
		total,
		totaltaxes,
		totalWithoutShipping,
	} = data;

	const getPrice = (price) => `$${parseFloat(price).toFixed(2)}`;

	const $main = $('.cartStep_3GuestPage, .cartStep_3LoggedInPage, .cartStep_1Page, .cartStep_4PaymentPage');
	const $shippingValue = $main.find('.shipping-value');
	const $methodPrice = $main.find('[data-method="clickCollect"]');
	const $totalValue = $main.find('.total-value');
	const $cartTotalValue = $main.find('.total-without-shipping');
	const $taxValue = $main.find('.tax-value');

	shipping && $($shippingValue).text(getPrice(shipping));
	shipping &&	$($methodPrice).text(getPriceOrFree(shipping));
	total && $($totalValue).text(getPrice(total));
	totalWithoutShipping && $($cartTotalValue).text(getPrice(totalWithoutShipping));
	totaltaxes && $($taxValue).text(getPrice(totaltaxes));
}

function setStockMiniCart(
	variantStockValue,
	addressName
) {
	variantStockValue.forEach(({
		Barcode,
		PickupStatus,
		PickupStatusMsg,
		IsHeavyItem,
	}) => {
		const $itemCartList = $(`.miniCart-item[data-item-barcode="${Barcode}"], .shoppingCartItem-content[data-item-barcode="${Barcode}"]:not([data-is-click-collect-not-available="True"])`);

		$itemCartList.each((_, itemCart) => {
			const isHeavyUncheckClass = getIsHeavyUncheckClass(IsHeavyItem);
			const $stockStatus = $(`<div class="stock-status mt-1 ${STOCK_CLASS[PickupStatus] || ''} ${isHeavyUncheckClass}">${PickupStatusMsg || ''}</div>`);
			const $shoppingCartStockStatus = $(`<div class="stock-status mt-1 ${STOCK_CLASS[PickupStatus] || ''} ${isHeavyUncheckClass}">${PickupStatusMsg || ''} at ${getNameStore(addressName)}</div>`);
			$(itemCart).find('.miniCart-stock').html($stockStatus);
			$(itemCart).find('.shoppingCartItem-stock').html($shoppingCartStockStatus);
		});
	});
}

export function getStoreList(storeList, regionId) {
	return new Promise((resolve) => {
		resolve({
			result: 'SUCCESS',
			response: storeList.map((store) => ({
				storeId: store.ContentLinkID,
				contentLinkID: store.ContentLinkID,
				fulfilmentNumber: store.storeId, // Use for header
				address: store.address,
				name: store.name,
				hours: store.hours,
				endTime: store.endTime,
				cutOffTime: store.cutOffTime,
				regionId: regionId || '',
			})),
		});
	});
}

export function getNameStore(name) {
	return `${storeNameShorter(name)} Store`;
}

export function saveStore(storeInfo, callBack) {
	saveSelectedStore(storeInfo, () => {
		dispatchEvent('[data-wg="RegionStorePopup"]', EVT_SET_REGION, storeInfo);
		callBack();
	});
}

export function saveStoreSuccess() {
	$('[data-wg="RegionStorePopup"]').trigger(EVENT_SETSTORE_SUCCESS);
}

export function getPriceOrFree(price) {
	const priceFloat = parseFloat(price || 0);
	return priceFloat ? '$' + priceFloat.toFixed(2) : 'FREE';
}

export function isStoreSeleted() {
	const {
		storeInfo: {
			contentLinkID,
			storeName,
		},
	} = checkLocalStorage();

	return storeName || contentLinkID;
}

export function closeNearbyStores() {
	$('.nearbyStores').trigger('list.close');
}

function updateHeavyClass(hasAnyHeavyItem) {
	const $section = $('.card-delivery-option, .availability-text');
	if (!window.enableChangeHeavyItemWording && hasAnyHeavyItem) {
		$section.addClass('is-heavy-uncheck');
	} else {
		$section.removeClass('is-heavy-uncheck');
	}
}

export function getIsHeavyUncheckClass(isHeavy) {
	return !window.enableChangeHeavyItemWording && isHeavy ? 'is-heavy-uncheck' : '';
}

export function handleSubmit(form, event, action) {
	const method = $(event.submitter).val();
	action[method || 'submit'](form, event);
}

export const DELIVERY_MAIN_CLASS = {
	ACTIVE_STEP_1: 'active-rural-step-1',
	ACTIVE_STEP_2: 'active-rural-step-2',
	IS_RURAL: 'is-rural-delivery',
	IS_STANDARD: 'is-standard-delivery',
	IS_NEXTDAY: 'is-nextday-delivery',
	IS_CNC: 'click-collect-selected',
	SELECTED: 'rural-or-standard-selected',
	INCLUDE_HEAVY_ITEM: 'include-heavy-item',
	IS_SAMEDAY: 'is-sameday-delivery',
};
export class RuralService {
	constructor($el) {
		this.$el = $el;
		this.$page = $($el);
	}

	onBackDeliveryForm() {
		this.$page.addClass(DELIVERY_MAIN_CLASS.ACTIVE_STEP_1).removeClass(DELIVERY_MAIN_CLASS.ACTIVE_STEP_2);
		if (this.$page.find('input[name="deliveryMethod"]:checked').val() == 'clickCollect') {
			this.setIgnoreValidate(false);
		} else {
			this.setIgnoreValidate(true);
		}
		this.resetDeliveryTabSelected();
	}

	resetDeliveryTabSelected() {
		this.$page
			.addClass(DELIVERY_MAIN_CLASS.IS_STANDARD)
			.removeClass(DELIVERY_MAIN_CLASS.IS_NEXTDAY)
			.removeClass(DELIVERY_MAIN_CLASS.IS_RURAL);
		$(this.$el).find('.delivery-tab-box:visible:nth(0) input').prop('checked', true);
	}

	registerEvent() {
		this.$page.find('.rural-address')
			.on('click', '.edit', () => {
				this.onBackDeliveryForm();
			}).on('click', '.delete', () => {
				this.onBackDeliveryForm();
				this.resetDeliveryForm();
			});
	}

	resetDeliveryForm() {
		const deliveryInputs = [
			'#firstNameDelivery',
			'#lastNameDelivery',
			'#addressDelivery',
			'#suburbDelivery',
			'#cityDelivery',
			'#stateProvinceDelivery',
			'#postcodeDelivery',
			'#companyDelivery',
		];

		this.$page.find(deliveryInputs.join(', ')).val('');
	}

	setIgnoreValidate(isIgnore) {
		const isUseDeliveryAddress = this.$page.find('[name="UseDeliveryAddress"]').prop('checked');
		const addressInputs = [
			'#phoneNumber',
		];

		const billingInputs = [
			'#firstNameBilling',
			'#lastNameBilling',
			'#addressBilling',
			'#suburbBilling',
			'#cityBilling',
			'#stateProvinceBilling',
			'#postcodeBilling',
			'#countryBilling',
		];

		const inputs = (isUseDeliveryAddress ? addressInputs : _.concat(addressInputs, billingInputs)).map((input) => input + ':not(.is-commercial)');

		if (isIgnore) {
			this.$page.find(inputs.join(', ')).addClass('ignore-validation');
		} else {
			this.$page.find(inputs.join(', ')).removeClass('ignore-validation');
		}
	}

	updateDeliveryMethod(event, callBack) {
		const isClickAndCollect = event.target.value === 'clickCollect';
		const isRuralOrStandardSelected = !isClickAndCollect;
		const disableRural = !window.ENABLE_RURAL_DELIVERY;

		this.setRuralOrStandarSelected(isRuralOrStandardSelected);

		if (disableRural || isClickAndCollect) {
			this.setIgnoreValidate(false);
		} else {
			this.setIgnoreValidate(true);
		}
		callBack();
	}

	renderAddressInfo(form) {
		const data = $(form).serializeArray().reduce((acc, cur) => {
			acc[cur.name] = cur.value;
			return acc;
		}, {});
		$(this.$el).find('[rural-address]').each(function() {
			const name = $(this).attr('rural-address');
			$(this).text(data[name] || '');
		});
		$(this.$el).find('.rural-address').show();
	}

	checkRuralDelivery(form) {
		return new Promise((resolve) => {
			this.$page.addClass(DELIVERY_MAIN_CLASS.ACTIVE_STEP_2).removeClass(DELIVERY_MAIN_CLASS.ACTIVE_STEP_1);
			const isRural = this.isRural();

			if (isRural) {
				this.$page
					.addClass(DELIVERY_MAIN_CLASS.IS_RURAL)
					.removeClass(DELIVERY_MAIN_CLASS.IS_STANDARD)
					.removeClass(DELIVERY_MAIN_CLASS.IS_NEXTDAY);
				const shippingMethodId = this.$page.find('.delivery-tab-item:visible').attr('for');
				this.$page.find(`input[name="deliveryMethod"][value="${shippingMethodId}"]`).prop('checked', true);
			} else {
				this.$page.removeClass(DELIVERY_MAIN_CLASS.IS_RURAL);
			}
			resolve(isRural);
			this.renderAddressInfo(form);
			this.setIgnoreValidate(false);
		});
	}

	isRural() {
		const postcodeDelivery = this.$page.find('[name="postcodeDelivery"]').val();
		return (window.RURAL_POSTCODES || '').split(',').includes(postcodeDelivery);
	}

	setRuralOrStandarSelected(isRuralOrStandard) {
		this.actionByMode(() => {
			if (isRuralOrStandard) {
				this.$page.addClass(DELIVERY_MAIN_CLASS.SELECTED);
			} else {
				this.$page.removeClass(DELIVERY_MAIN_CLASS.SELECTED);
			}
		});
	}

	updateHeavyState(includeHeavyItem) {
		this.actionByMode(() => {
			if (includeHeavyItem) {
				this.$page.addClass(DELIVERY_MAIN_CLASS.INCLUDE_HEAVY_ITEM);
			} else {
				this.$page.removeClass(DELIVERY_MAIN_CLASS.INCLUDE_HEAVY_ITEM);
			}
		});
	}

	actionByMode(onRural, offRural = () => {}) {
		if (window.ENABLE_RURAL_DELIVERY) {
			onRural();
		} else {
			offRural();
		}
	}
}

export class GuaranteedNextdayService {
	constructor($el) {
		this.$nextdayDeliveryOption = $('.guaranteed-nextday');
		this.$samedayDeliveryOption = $('[shipping-type="sameday"]');
		this.$page = $($el);
	}

	registerEvent() {
		this.$page.on('click', '.delivery-description', (event) => {
			const $currentTarget = $(event.currentTarget);
			const shippingMethodId = $currentTarget.attr('shipping-method-id');
			const shippingType = $currentTarget.attr('shipping-type');

			$(`.delivery-tab-item[for="${shippingMethodId}"]`).trigger('click');

			this.actionByType(shippingType, {
				nextday: () => {
					this.addClassNextdayForMain();
				},
				standard: () => {
					this.addClassStandardForMain();
				},
				sameday: () => {
					this.addClassSamedayForMain();
				}
			});
		});

		this.$page[0].addEventListener('checkStoreVariantDetail',  () => {
			this.checkNextdayDelivery();
		});

		this.$page.on('change', '.delivery-radio', (event) => {
			event.preventDefault();
			const $tab = $(event.target).closest('.delivery-tab-box');
			if ($tab.hasClass('show-is-nextday') || $tab.hasClass('show-is-standard')) {
				this.checkNextdayDelivery();
			}
		});
	}

	addClassSamedayForMain() {
		this.$page
			.removeClass(DELIVERY_MAIN_CLASS.IS_STANDARD)
			.removeClass(DELIVERY_MAIN_CLASS.IS_NEXTDAY)
			.addClass(DELIVERY_MAIN_CLASS.IS_SAMEDAY);
	}

	addClassNextdayForMain() {
		this.$page
			.removeClass(DELIVERY_MAIN_CLASS.IS_STANDARD)
			.removeClass(DELIVERY_MAIN_CLASS.IS_SAMEDAY)
			.addClass(DELIVERY_MAIN_CLASS.IS_NEXTDAY);
	}

	addClassStandardForMain() {
		this.$page
			.removeClass(DELIVERY_MAIN_CLASS.IS_NEXTDAY)
			.removeClass(DELIVERY_MAIN_CLASS.IS_SAMEDAY)
			.addClass(DELIVERY_MAIN_CLASS.IS_STANDARD);
	}

	actionByType(type, action) {
		return action[type] && action[type]();
	}

	checkNextdayDelivery() {
		return new Promise((resolve, reject) => {
			const isCNC = $(this.$page).find('.delivery-radio:checked').val() === 'clickCollect';
			if (window.ENABLE_GUARANTEED_NEXTDAY_DELIVERY && !isCNC) {
				const postcode = $('#postcodeDelivery').val();
				const endpoint = '/api/findinstore/check-stock-data-by-postcode/';
				callApi(endpoint, {
					postcode,
					isCheckout: true,
				}).then((res) => {
					if (res.result === 'SUCCESS') {
						const storeList = _.get(res, 'response', []);
						const {
							GuaranteedNextDayDelivery,
							SameDayDelivery,
						} = this.checkStoreAvailable(storeList);

						this.updateNextdayOption({
							GuaranteedNextDayDelivery,
							SameDayDelivery,
						});

						resolve(GuaranteedNextDayDelivery);
					} else {
						reject(false);
					}
				});
			} else {
				reject(false);
			}
		});
	}

	checkStoreAvailable(storeList) {
		const targetData = {
			GuaranteedNextDayDelivery: false,
			SameDayDelivery: false,
		};

		return storeList.reduce((acc, store) => {
			for (const key in acc) {
				acc[key] = acc[key] || _.get(store, `StockData.${key}.IsAvailableForDelivery`);
			}

			return acc;
		}, targetData);
	}

	updateNextdayOption({ GuaranteedNextDayDelivery, SameDayDelivery }) {
		const {
			ENABLE_SAME_DAY_DELIVERY: enableSameDay,
			ENABLE_GUARANTEED_NEXTDAY_DELIVERY: enableNextDay
		} = window;

		const showSameday = SameDayDelivery && enableSameDay;
		const showNextday = !showSameday && GuaranteedNextDayDelivery && enableNextDay;

		[
			{
				isAvailable: showNextday,
				$el: this.$nextdayDeliveryOption,
			},
			{
				isAvailable: showSameday,
				$el: this.$samedayDeliveryOption,
			}
		].forEach(({ isAvailable, $el }) => {
			if (isAvailable) {
				$el.show();
			} else {
				$el.hide();
			}
		});
	}

	activeNextday() {
		this.$nextdayDeliveryOption.show();
		this.$page.find('.delivery-description[shipping-type="nextday"]').trigger('click');
	}

	activeStandard() {
		this.$page.find('.delivery-description[shipping-type="standard"]').trigger('click');
	}
}

export function isSameDay() {
	const [h, m, s] = (window.SAME_DAY_DELIVERY_TIME || '00:00:00').split(':');
		const date = new Date();
		const currentDate = new Date();
		date.setHours(h);
		date.setMinutes(m);
		date.setSeconds(s);

	const isAfter = currentDate.getTime() <= date.getTime();
	const isDayOfWeek = (window.SAME_DAY_DELIVERY_DAYS_OF_WEEK || []).includes(currentDate.getDay().toString());
	const enableSameDay = window.ENABLE_SAME_DAY_DELIVERY || false;

	return isDayOfWeek && isAfter && enableSameDay;
}



// WEBPACK FOOTER //
// ./checkout.js